export default {
  requestVideo_title: 'Solicitar video',
  requestVideo_unit_label: 'Selecciona una unidad',
  requestVideo_unit_placeholder: 'Busca por nombre o número de serie',
  requestVideo_unit_none: 'No se encontraron unidades LightMetrics.',
  requestVideo_unit_loading: 'Buscando unidades...',
  requestVideo_unit_error: 'No se pudieron cargar las unidades.',
  requestVideo_unit_loadMore: 'Cargar más unidades',
  requestVideo_unit_empty: 'Selecciona una unidad para solicitar un video.',
  requestVideo_unit_notFound: 'Esa cámara no se encontró entre tus unidades LightMetrics.',
  requestVideo_zone_note: 'Las horas se muestran en {timeZone}.',
  requestVideo_zone_fallback: 'Esta unidad no tiene zona horaria configurada. Las horas se muestran en UTC.',
  requestVideo_days_loading: 'Cargando días con actividad...',
  requestVideo_days_none: 'No hay actividad en los últimos 90 días.',
  requestVideo_days_error: 'No se pudieron cargar los días con actividad.',
  requestVideo_day_label: 'Día',
  requestVideo_day_prev: 'Día anterior con actividad',
  requestVideo_day_next: 'Día siguiente con actividad',
  requestVideo_day_choose: 'Elegir un día',
  requestVideo_trips_title: 'Viajes',
  requestVideo_trips_loading: 'Cargando viajes...',
  requestVideo_trips_none: 'No hay viajes en este día.',
  requestVideo_trips_error: 'No se pudieron cargar los viajes.',
  requestVideo_trip_driver: 'Conductor: {name}',
  requestVideo_trip_noDriver: 'Sin conductor',
  requestVideo_retry: 'Reintentar',
  requestVideo_window_title: 'Ventana de 5 minutos',
  requestVideo_window_prev: '5 minutos anteriores',
  requestVideo_window_next: '5 minutos siguientes',
  requestVideo_trail_loading: 'Cargando recorrido...',
  requestVideo_trail_empty: 'No hay datos de recorrido en esta ventana.',
  requestVideo_trail_error: 'No se pudo cargar el recorrido. Aún puedes elegir el rango.',
  requestVideo_legend_driving: 'En movimiento',
  requestVideo_legend_idling: 'En ralentí',
  requestVideo_legend_stopped: 'Detenido',
  requestVideo_legend_camera: 'Evento de cámara',
  requestVideo_marker_label: 'Evento de cámara a las {time}',
  requestVideo_handle_start: 'Inicio del clip',
  requestVideo_handle_end: 'Fin del clip',
  requestVideo_range_title: 'Rango del clip',
  requestVideo_range_from: 'Desde',
  requestVideo_range_to: 'Hasta',
  requestVideo_lmTrips_other: 'Otro viaje de LightMetrics',
  requestVideo_lmTrips_hint: 'LightMetrics solo graba dentro de uno de sus propios viajes. La parte atenuada es otro viaje: haz clic en ella para mover el clip allí.',
  requestVideo_range_duration: 'Duración: {value}',
  requestVideo_rangeError_tooLong: 'El clip puede durar como máximo 5 minutos.',
  requestVideo_rangeError_outside: 'El clip debe quedar dentro de la ventana seleccionada.',
  requestVideo_rangeError_missing: 'Selecciona un viaje para elegir el rango del clip.',
  requestVideo_private_label: 'Solicitud de clip privado',
  requestVideo_private_tooltip: 'Un clip privado solo es visible para los usuarios con permiso para ver clips privados.',
  requestVideo_submit: 'Solicitar video',
  requestVideo_sending: 'Enviando...',
  requestVideo_cancel: 'Cancelar',
  requestVideo_toast_title: 'Video solicitado',
  requestVideo_toast_body: 'El clip fue solicitado correctamente. Aparecerá en Video > Solicitados cuando la cámara lo suba.',
  requestVideo_error_alreadyRequested: 'Este clip ya fue solicitado.',
  requestVideo_error_cameraNotFound: 'No se encontró la cámara.',
  requestVideo_error_rangeNotAvailable: 'La cámara no puede entregar video de ese rango. Elige otro.',
  requestVideo_error_generic: 'No se pudo enviar la solicitud. Inténtalo de nuevo.',
};
